<app-header></app-header>      


<as-split unit="percent" id="mainContainerSplit" #split="asSplit" (dragEnd)="revalidateMap()">
    <as-split-area [size]="arealsize" #area1="asSplitArea"> 
        <div style="position:relative">
            <spinner [id]="'map'" [show]="activeSpinner"></spinner>
            <div id="mapid">
                <button class="btn btn-main-data btn-dark openCloseDataTab" id="datatab" (click)="showDataTab=!showDataTab;revalidateMap()">
                    {{'header.data' | translate}}
                </button>
            </div>
            <div   *ngIf="maptitlelabel"> {{maptitlelabel}} </div>
            
        </div> 
        <app-footer></app-footer>
  
  <!-- <app-mapsearch></app-mapsearch> -->
  <app-sidebar 
  [currentZoomLevel]="currentZoomLevel" [activeLayers]="activeLayers" [activeBaseLayer]="activeBaseLayer" [baseLayers]="baseLayers"  [groupList]="OverlayLayers" ></app-sidebar> 
    <!-- <app-maplegend [showLegend]="showLegend" ></app-maplegend>        -->
 </as-split-area>
<as-split-area usetransition="true" [visible]="showDataTab" [size]="area2size" minSize="15" maxSize="25" [class]="!showDataTab? 'as-split-area d-none as-hidden': 'as-split-area'" (dragEnd)="revalidateMap()" #area2="asSplitArea">
            <button class="" _ngcontent-c1="" (click)="showDataTab=!showDataTab;revalidateMap()" [class]="!showDataTab? 'as-split-area d-none as-hidden info_close': 'info_close'">
                <i _ngcontent-c1="" class="fas fa-times-circle"></i>
            </button>
    <app-infobox></app-infobox>
</as-split-area>
</as-split>
